/**
 * Ensure a URL string has an https:// scheme for use in href attributes.
 * Returns null if the value is blank or doesn't look like a URL.
 */
export function ensureUrl(value: string | null | undefined): string | null {
  if (!value?.trim()) return null
  const trimmed = value.trim()
  if (/^https?:\/\//i.test(trimmed)) return trimmed
  // Only treat as a URL if it contains a dot (domain-like)
  if (trimmed.includes(".")) return `https://${trimmed}`
  return null
}
